// extracted by mini-css-extract-plugin
export default {"rating":"nz-z","numberOfStars":"oz-z","count":"pz-z","barGraphSpacing":"qz-z","barGraph":"rz-z"};